import React from "react";
import { Identifiable, Project } from "@planzone/dto";

function useElementDrag(
  graphRef: React.RefObject<HTMLDivElement | null>,
  project: Identifiable<Project> | null,
  events: {
    edit: (data: number) => void;
    stopDrag: () => void;
  },
) {
  const [canMove, setCanMove] = React.useState(false);
  const hasSelection = () => canMove;
  const resetSelection = () => setCanMove(false);
  const selectThumb = (initialOffset: number = 0) => {
    graphRef.current &&
      events.edit(getNextMoveValue(graphRef.current, initialOffset));
    setCanMove(true);
  };
  const update = (nextValue: number) => events.edit(nextValue);
  const getNextMoveValue = (graphElement: HTMLDivElement, offset: number) => {
    const rect = graphElement.getBoundingClientRect();
    return Math.round(offset - rect.left);
  };
  const canUpdate = (offset: number) => {
    return true;
  };

  React.useEffect(() => {
    const cancelSelection = () => {
      if (hasSelection()) {
        resetSelection();
        events.stopDrag();
      }
    };
    const dispatchChange = (e: MouseEvent | TouchEvent) => {
      const mouseEvent = e as MouseEvent;
      const touchEvent = e as TouchEvent;

      if (graphRef.current) {
        const nextValue = getNextMoveValue(
          graphRef.current,
          !!mouseEvent.clientX
            ? mouseEvent.clientX
            : touchEvent.changedTouches.length > 0
              ? touchEvent.changedTouches[0].clientX
              : 0,
        );

        hasSelection() && canUpdate(nextValue) && update(nextValue);
      }
    };

    window.addEventListener("touchmove", dispatchChange);
    window.addEventListener("mousemove", dispatchChange);
    window.addEventListener("mouseup", cancelSelection);
    window.addEventListener("touchend", cancelSelection);

    return () => {
      window.removeEventListener("touchmove", dispatchChange);
      window.removeEventListener("mousemove", dispatchChange);
      window.removeEventListener("mouseup", cancelSelection);
      window.removeEventListener("touchend", cancelSelection);
    };
  });

  return { startDrag: selectThumb };
}

export { useElementDrag };
